module.exports = __webpack_public_path__ + "img/klaas.10d9b9de.png";